import React from "react";
import Preloader from "../helper/Preloader";

import HeaderTwo from "../components/HeaderTwo";
import FooterTwo from "../components/FooterTwo";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import TextInput from "../components/TextInput";

import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { handleError } from "../utils/functions";
import SubmitButton from "../components/SubmitButton";
import axiosInstance from "../config/axios.config";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const schema = Yup.object().shape({
  email: Yup.string().email("Invalid email format").required("Email is required"),
});

const AccountPage = () => {
  const { t } = useTranslation();

  const {
    handleSubmit,
    register,
    setValue,
    formState: { isSubmitting, errors },
  } = useForm({ resolver: yupResolver(schema), mode: "all" });

  const onSubmit = async (data) => {
    try {
      const { data: res } = await axiosInstance.post("/user/find", data);
      if (!res.error) {
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderTwo category={true} />

      <section className="account py-80">
        <div className="container">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row justify-content-center align-items-center">
              <div className="col-md-5">
                <div className="card">
                  <div className="card-body py-30 px-30">
                    {/* Personal Details Section */}
                    <h3 className="my-30 text-center">{t("findAccount.title")}</h3>
                    <div className="mb-24">
                      <TextInput
                        name={"email"}
                        placeholder={t("enterEmail")}
                        isRequired
                        label={t("email")}
                        type={"email"}
                        register={register}
                        onChange={(e) => setValue("email", e.target.value)}
                        error={errors.email}
                      />
                    </div>
                    <div className="mt-30 text-center">
                      <SubmitButton isSubmitting={isSubmitting}>
                        {t("findAccount.submit")}
                      </SubmitButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>

      {/* FooterTwo */}
      <FooterTwo />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default AccountPage;
